import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { EstablishEntityIBANsClientResponse } from '../@types/establishEntityIbans'

export type AgentSessionTypes = [string, string, number, boolean] | null

type Store = {
  establishEntityIbans: EstablishEntityIBANsClientResponse | null
  setEstablishEntityIbans: (
    establishEntityIbans: EstablishEntityIBANsClientResponse,
  ) => void
}

export const useEstablishEntityIbansStore = create<Store>()(
  devtools(
    (set) => ({
      establishEntityIbans: null,
      setEstablishEntityIbans: (establishEntityIbans) =>
        set({ establishEntityIbans }),
    }),
    { name: 'EstablishEntityIbansStore' },
  ),
)
